/**
 * Error display utilities
 * @module shared-cart/ui/error
 */

/**
 * Displays an error message to the user via the cart error element
 * @param {string} message - The error message to display
 */
export function displayError(message: string) {
  const errorEl =
    document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
  if (errorEl) {
    errorEl.textContent = message;
  }
}
